<template>
    <div    class="">
        <slide-over-panel     v-model:show="showEditModal">
            <template   #title>
                <span   v-if="editingDisplayTemplate !== null">
                    Editing {{ editingDisplayTemplate.name }}
                </span>
            </template>

            <template   #content>
                <!-- Template Name Input -->
                <div    class="py-4">
                    <floating-input     label="Template Name"
                                        v-model:value="editingDisplayTemplate['name']"
                                        class=""
                                        id="template_name"
                    ></floating-input>
                </div>

                <!-- Template Devices Select -->
                <div>
                    Select devices to include on the display
                    (Recommended Max 10, You have {{ editingDisplayTemplate.devices.length }})
                </div>

                <div    class="pb-4">
                    <select2    v-model:value="editingDisplayTemplate['devices']"
                                :options="allowedPoints"
                                :allow-clear="true"
                                :multiple="true"
                                :name="'devices_' + editingDisplayTemplateIndex"
                                placeholder="Select Devices"
                    ></select2>
                </div>


                <!-- View Passcode If it is Available -->
                <div    v-if="editingDisplayTemplate.passcode !== null && editingDisplayTemplate.passcode !== ''"
                        class="py-4">
                    <floating-input     label="Passcode"
                                        v-model:value="editingDisplayTemplate['passcode']"
                                        id="passcode"
                                        :readonly="true"
                    ></floating-input>
                </div>


                <!-- Refresh Rate -->
                <div    class="py-4">
                    <floating-input     label="Refresh Rate (seconds)"
                                        v-model:value="editingDisplayTemplate['refresh_rate']"
                                        id="refresh_rate"
                    ></floating-input>
                </div>

                <!-- Save -->
                <button-blue-primary    v-if="editingDisplayTemplate !== null && !creatingDisplayTemplate && canUpdateDisplayTemplate()"
                                        @click="saveEditedTemplate"
                >
                    Save Display Template
                </button-blue-primary>

                <!-- Create New -->
                <button-green-primary   v-else-if="canCreateDisplayTemplate()"
                                        @click="saveCreatedTemplate"
                >
                    Create Template
                </button-green-primary>
            </template>
        </slide-over-panel>

        <h2>Pro-Display Template</h2>

        <ajax-table     :data="tableData"
                        v-model:loading="ajaxTable.loading"
                        v-model:search="ajaxTable.search"
                        v-model:sort-by="ajaxTable.sortBy"
                        v-model:sort-desc="ajaxTable.sortDesc"
                        v-model:page="ajaxTable.page"
                        v-model:items-per-page="ajaxTable.itemsPerPage"
                        v-model:page-info="ajaxTable.pageInfo"
                        :headers="tableHeaders"
                        :exportable="false"
                        @loadData="loadData"
                        @rowSelected="editDisplayTemplate"
        >
            <template   #search-right
                        class="self-start flex items-center w-full md:w-auto ml:0 md:ml-2">
                <button-green-primary   v-if="canCreateDisplayTemplate()"
                                        @click="createDisplayTemplate"
                >
                    <div    class="inline-flex">
                        <span   class="lnr icon-plus-circle mr-2"></span>
                        <span>Create Pro-Display Template</span>
                    </div>
                </button-green-primary>
            </template>

            <template   #col-2="tableProps">
                <div    class="flex flex-row flex-wrap">
                    <span   v-for="(device, deviceIndex) in tableProps.row.devices"
                            class="px-4 py-2"
                    >
                        {{ allowedPoints[device] }}
                    </span>
                </div>
            </template>
        </ajax-table>
    </div>
</template>

<script>
import axios from "axios"
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import {ajaxTableMixin} from "@/mixins/ajaxTableMixin";
import AjaxTable from "@/components/elements/AjaxTable";
import SlideOverPanel from "@/components/elements/SlideOverPanel";
import FloatingInput from "@/components/elements/FloatingInput";
import Select2 from "@/components/elements/select2"
import ButtonBluePrimary from "@/components/elements/buttons/ButtonBluePrimary";
import ButtonGreenPrimary from "@/components/elements/buttons/ButtonGreenPrimary";

export default {
    name: "ProDisplayTemplateIndex",
    mixins: [SonicuCoreMixin, iconNamesMixin, ajaxTableMixin,],
    components: {ButtonGreenPrimary, ButtonBluePrimary, FloatingInput, SlideOverPanel, AjaxTable, Select2},
    props: {
        
    },
    data() {
        return {
            tableHeaders: [
                {
                    name: 'Display Template Name',
                    key: 'name',
                    sortBy: 'name',
                },
                {
                    name: 'Devices',
                    key: 'devices',
                    sortBy: '',
                },
                {
                    name: 'Refresh Rate (seconds)',
                    key: 'refresh_rate',
                    sortBy: '',
                }
            ],
            tableData: [],
            allowedPoints: [],

            // Editing Modal
            showEditModal: false,
            editingDisplayTemplateIndex: null,
            editingDisplayTemplate: null,
            creatingDisplayTemplate: false,
            name: '',
        }
    },
    created() {
    },
    mounted() {
        
    },
    methods: {
        loadData() {
            this.ajaxTable.loading = true
            axios.get(this.company.buildCompanyApiInternalRoute('pro-display-template'), {
                params: this.ajaxTable,
            }).then(response => {
                let data = response.data
                if (`${data.meta.requestNumber}` !== `${this.ajaxTable.requestNumber}`) {
                    return
                }
                this.tableData = this.parseDeviceInData(data.data)
                this.ajaxUpdateTableData(this.tableData)

                this.allowedPoints = data.meta.allowedPoints
            }).catch(error => {
                console.log(error)
            }).then(() => {
                this.ajaxTable.loading = false
            })
        },
        parseDeviceInData(tableRows) {

            _.each(tableRows, (row, index) => {
                tableRows[index].devices = row.devices
            })

            return tableRows
        },
        editDisplayTemplate(index) {
            // TODO. Add middle-click support to allow a user to middle click a row & edit it in a new tab.
            this.editingDisplayTemplateIndex = index
            this.editingDisplayTemplate = this.tableData[index]
            this.showEditModal = true
        },
        saveEditedTemplate() {
            if (!this.canUpdateDisplayTemplate()) {
                return
            }

            axios.put(this.company.buildCompanyApiInternalRoute(`pro-display-template/${this.editingDisplayTemplate.id}`), this.editingDisplayTemplate
            ).then(response => {

            }).catch(error => {
                console.log(error)
            }).then(() => {
                this.closeEditModal()
            })
        },
        createDisplayTemplate() {
            this.tableData.push({
                name: '',
                devices: [],
                passcode: null,
                refresh_rate: 30,
            })
            this.editingDisplayTemplateIndex = this.tableData.length - 1
            this.editingDisplayTemplate = this.tableData[this.editingDisplayTemplateIndex]
            this.creatingDisplayTemplate = true
            this.showEditModal = true
        },
        saveCreatedTemplate() {
            if (!this.canCreateDisplayTemplate()) {
                return
            }

            axios.post(this.company.buildCompanyApiInternalRoute(`pro-display-template`), this.editingDisplayTemplate
            ).then(response => {

            }).catch(error => {

            }).then(() => {
                this.closeEditModal()
            })

        },
        closeEditModal() {
            this.showEditModal = false
            this.creatingDisplayTemplate = false
            this.editingDisplayTemplateIndex = null
            this.editingDisplayTemplate = null

            console.log(`Trigger REload`)
            this.loadData()
        },
        canUpdateDisplayTemplate() {
            return this.permissions.can('update_pro_display_template')
        },
        canCreateDisplayTemplate() {
            console.log(`Checking for creating Display Template: ` + this.permissions.can('create_pro_display_template'))
            return this.permissions.can('create_pro_display_template')
        },
    },
    computed: {
    },
    watch: {
      showEditModal(val, old) {
        if (!val) {
          this.closeEditModal()
        }
      },
    },
}
</script>

<style scoped>

</style>